import Vue from "vue";
import Router from "vue-router";
import { routes } from "./config/router.config";
Vue.use(Router);
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: "history",
  routes
});

